import { React } from "react";
import useFetch from "../functions/useAxios";
import Calendar from "react-calendar";
import useClock from "../functions/useClock";
import ReactPlayer from "react-player";
import { useRecoilValue } from "recoil";
import { usersAtom } from "../atoms";
import "react-calendar/dist/Calendar.css";
//import { useFetchWrapper } from "../functions/useFetchWrapper";

function Home() {
  /*
  const fetchWrapper = useFetchWrapper();
  const [data2, setData2] = useState(null);
  const toggleBath = useCallback(() => {
    fetchWrapper
      .htmlget("/api/test/ip")
      .then((data) => {
        // 데이터 처리
        setData2(data.data);
        console.log(data.data);
      })
      .catch((error) => {
        // 에러 처리
        setData2(error.data);
        console.error("error");
      });
  }, [fetchWrapper]);*/
  const times = useClock();
  const data = useFetch("/api/test/hello").data;
  const data2 = useFetch("/api/test/ip").data;
  const authdata = useRecoilValue(usersAtom);
  return (
    <div>
      <div>{times}</div>
      <div>{JSON.stringify(authdata)}</div>
      <div className="row">
        <div className="col">{data}</div>
        <div className="col">{data2}</div>
      </div>
      <div className="row">
        <div className="col">
          <ReactPlayer
            url=""
            playing={true}
            muted={true}
            controls={false}
            loop={true}
          />
        </div>
        <div className="col">
          <Calendar />
        </div>
      </div>
    </div>
  );
}
export default Home;
